import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/department",
    component: LayoutPage,
    children: [
      {
        path: "",
        name: "department-page",
        component: () => import("../../views/Department/DepartmentPage.vue"),
        meta: {
          title: "Department",
          titleLocalizationCode: "Department",
          desc: "Department page",
          descLocalizationCode: "Department_Page",
          sidebarElement: false,
          permissionCodes: [
            "Department.Read",
            "Department.Add",
            "Department.Edit",
            "Department.Delete",
          ],
        },
      },
    ],
  },
];
